import { Box, Paper, Typography, styled } from '@mui/material';

export const Wrapper = styled(Box)({
	display: 'flex',
	flexDirection: 'column',
	gap: '12px',
	marginBottom: '16px',
});

export const Direction = styled(Box)({
	display: 'flex',
	flexDirection: 'column',
	gap: '4px',
	minWidth: 0,
});

export const Label = styled(Typography)({
	color: '#64748B',
	fontSize: '11px',
	fontWeight: 500,
	textTransform: 'uppercase',
});

export const PaymentCard = styled(Paper)(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	gap: '6px',
	minWidth: '0',
	padding: '16px 20px',
	border: `1px solid ${theme.palette.divider}`,
	borderRadius: '16px',
	backgroundColor: theme.palette.background.paper,
	boxShadow: 'none',
}));
